import React, { useState } from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import PeriodSelector from './PeriodSelector';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchApiStats } from '../api/monitoringApi';

const StatGrid = styled.div`display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 16px;
  @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); }
`;
const Stat = styled.div`text-align: center;`;
const StatLabel = styled.div`font-size: 12px; color: #6b7280;`;
const StatValue = styled.div`font-size: 20px; font-weight: 700; color: #111827;`;

const Section = styled.div`margin-top: 16px;`;
const SectionTitle = styled.div`font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 8px;`;

const Table = styled.table`width: 100%; border-collapse: collapse; font-size: 13px;`;
const Th = styled.th`text-align: left; padding: 6px 8px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; color: #6b7280; font-weight: 600;`;
const Td = styled.td`padding: 6px 8px; border-bottom: 1px solid #f3f4f6; color: #374151;`;

const BarRow = styled.div`display: flex; gap: 8px; flex-wrap: wrap;`;
const BarItem = styled.div`
  font-size: 12px; padding: 4px 10px; border-radius: 6px;
  background: ${p => p.$code < 400 ? '#d1fae5' : p.$code < 500 ? '#fef3c7' : '#fee2e2'};
  color: ${p => p.$code < 400 ? '#047857' : p.$code < 500 ? '#b45309' : '#dc2626'};
  span { font-weight: 700; }
`;

export default function ApiStatsPanel({ refreshKey }) {
  const [period, setPeriod] = useState('24h');
  const { data, isLoading, error } = useMonitoringData(() => fetchApiStats(period), [period, refreshKey]);

  return (
    <Panel title="API 요청 통계" isLoading={isLoading} error={error}
      actions={<PeriodSelector value={period} onChange={setPeriod} />}>
      {data && <>
        <StatGrid>
          <Stat><StatLabel>총 요청</StatLabel><StatValue>{data.total_requests?.toLocaleString()}</StatValue></Stat>
          <Stat><StatLabel>평균 응답</StatLabel><StatValue>{data.avg_response_time}ms</StatValue></Stat>
          <Stat><StatLabel>P95 응답</StatLabel><StatValue>{data.p95_response_time}ms</StatValue></Stat>
          <Stat><StatLabel>에러율</StatLabel><StatValue style={{color: data.error_rate > 5 ? '#ef4444' : undefined}}>{data.error_rate}%</StatValue></Stat>
        </StatGrid>

        <Section>
          <SectionTitle>상태코드 분포</SectionTitle>
          <BarRow>
            {Object.entries(data.status_distribution || {}).map(([code, cnt]) => (
              <BarItem key={code} $code={Number(code)}>{code}: <span>{cnt}</span></BarItem>
            ))}
          </BarRow>
        </Section>

        <Section>
          <SectionTitle>Top 10 엔드포인트</SectionTitle>
          <div style={{ overflowX: 'auto' }}>
            <Table>
              <thead><tr><Th>Method</Th><Th>URL</Th><Th>호출 수</Th><Th>평균 응답</Th></tr></thead>
              <tbody>
                {data.top_endpoints?.map((e, i) => (
                  <tr key={i}><Td>{e.method}</Td><Td>{e.url}</Td><Td>{e.count}</Td><Td>{e.avg_time_ms}ms</Td></tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Section>
      </>}
    </Panel>
  );
}
